import { useEffect } from 'react';

export const useFocusLayoutBodyLockScrollFix = (
    enable = true,
    id = 'focus-layout',
) => {
    useEffect(() => {
        const focusLayout = document.getElementById(id);
        if (!focusLayout) {
            return;
        }
        if (!enable) {
            focusLayout.style = {};
            return;
        }

        // Setting height to 100% to prevent layout shift when modal is open
        // and body scroll is locked. The body-scroll-lock library achieves
        // this by adding a negative top padding to the body, which throws
        // off the layout of the page when scrolled before opening the modal.
        // https://github.com/rick-liruixin/body-scroll-lock-upgrade/blob/10bfd2678c1c29a265b2847e5203a142da0fa63b/src/body-scroll-lock.ts#L150
        // Setting height to 100% permanently is also not desirable, since it
        // would conflict with mobile top and bottom safe areas, leading to
        // inconsistent spacing between the mobile web app, and the native
        // app's web view.
        // https://github.com/Perpay/perpay-web/pull/5654/files#diff-52591afe4d2b491b21347607eb3901f854b573e236b3687d66fc6a7a03b4333bR13
        focusLayout.style.height = '100%';
    }, [enable, id]);
};
